export const handleStatusCode422 = async (error, setStatusCode): Promise<void> => {
  const read = await error.body.getReader().read();
  const value: number[] = read.value;
  const errorCode: string = JSON.parse(String.fromCharCode(...value)).error;
  setStatusCode({ status: error.status, errorCode });
};
